<template>
  <div>
    <div class="u-padd-top-qtr u-padd-btm u-padd-sides" style="margin-top: 30px;">
      <div class="video">
        <div class="video__container">
          <div class="video-wrapper">
            <video preload="metadata" controls="true" autoplay="true">
              <source :src="src" type="video/mp4" />
            </video>
          </div>
          <div
            v-if="showTitle"
            class="u-flex u-flex--row u-flex--align-items-center u-mrg-top"
          >
            <span class="play-btn-sm"></span>
            <h3 class="h-sm u-mrg-none" v-html="title"></h3>
          </div>
          <div v-if="modalContent" v-html="modalContent"></div>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: "",
    modalContent: "",
    showTitle: {
      type: Boolean,
      default: false,
    },
    isActive: false,
    modalShow: {
      type: Boolean,
      default: false,
    },
    title: ""
  },
  data() {
    return {
      shown: false,
    };
  },
  mounted() {
    this.shown = this.modalShow;
  },
};
</script>
